export enum MapProvider {
  GMap = 0,
  Bing = 1
}
